import Swiper from "swiper"

export default class PSlider {

  constructor (el) {
    this.el = el
    this.slider = null
    this.slides = this.el.querySelectorAll('.swiper-slide')
  }

  init () {
    this.initSlider()
  }

  getActiveSlideIndex () {
    let index = null
    this.slides.forEach((el, i) => {
      if (el.classList.contains('active')) {
        index = i
      }
    });

    return index
  }

  initSlider () {
    this.slider = new Swiper(this.el, {
      slidesPerView: 'auto',
      initialSlide: this.getActiveSlideIndex(),
      watchOverflow: true,
      watchSlidesProgress: true,
      centerInsufficientSlides: true
    })
  }

  destroySlider () {
    if (this.slider) {
      this.slider.destroy()
      this.slider = null
    }
  }

}
